import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export interface Accessory {
    articleNumber: string;
    description: string;
    price: number;
    count: number;
    unit: string;
}

interface AccessoryState {
    items: Accessory[];
}

const initialState: AccessoryState = {
    items: [],
};

interface SetAccessoryCountPayload {
    articleNumber: string;
    description: string;
    price: number;
    count: number;
    unit: string;
}

const accessorySlice = createSlice({
    name: 'accessory',
    initialState,
    reducers: {
        setAccessoryCount: (state, action: PayloadAction<SetAccessoryCountPayload>) => {
            const {articleNumber, description, price, count, unit,} = action.payload;
            const index = state.items.findIndex(item => item.articleNumber === articleNumber);

            if (count <= 0) {
                if (index !== -1) state.items.splice(index, 1);
            } else if (index !== -1) {
                state.items[index].count = count;
            } else {
                state.items.push({articleNumber, description, price, count, unit});
            }
        },
    },
    extraReducers: builder => {
        builder.addCase(
            'persist/REHYDRATE', (state, action: any) => {
                if (action.payload && action.payload.project?.accessory?.items) {
                    return {
                        ...state,
                        items: action.payload.project.accessory.items
                    };
                }
                return state;
            }
        )
    }
});

export const {setAccessoryCount} = accessorySlice.actions;
export default accessorySlice.reducer;
